import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import Segment, { SegmentContainer } from "components/atoms/Segment";
import DataObjectJobHomeOverview from "containers/DataObjectJobHomeOverview";
import DataSetHomeOverview from "containers/DataSetHomeOverview";
import DataSetInsightsHomeOverview from "containers/DataSetInsightsHomeOverview";
import ViewsHomeOverview from "containers/ViewsHomeOverview";
import ViewInsightsHomeOverview from "containers/ViewInsightsHomeOverview";
import SchemaModelHomeOverview from "containers/SchemaModelHomeOverview";
import { useCallback, useEffect, useState } from "react";

function Home({ tenant }) {
    const [selectedDataSetId, setSelectedDataSetId] = useState(null);
    const [selectedViewId, setSelectedViewId] = useState(null);
    const [dataSetInsightsRefreshFlag, setDataSetInsightsRefreshFlag] = useState(false);
    const [activeTab, setActiveTab] = useState("datasets");

    const onDataSetSelected = useCallback(
        (dataSetId) => {
            setSelectedDataSetId(dataSetId);
            setDataSetInsightsRefreshFlag(!dataSetInsightsRefreshFlag);
        },
        [dataSetInsightsRefreshFlag],
    );

    const onViewSelected = useCallback((viewId) => {
        setSelectedViewId(viewId);
    }, []);

    const onTabChange = useCallback((tab) => {
        setActiveTab(tab);
        if (tab === "datasets") {
            setSelectedViewId(null);
        } else {
            setSelectedDataSetId(null);
        }
    }, []);

    useEffect(() => {
        return () => {
            setSelectedDataSetId(null);
            setSelectedViewId(null);
            setDataSetInsightsRefreshFlag(false);
        };
    }, []);

    return (
        <FlexContainerLayout contentClassName="flex-1 flex-col flex size-full gap-4">
            <div className="relative flex size-full flex-1 flex-col gap-4 lg:flex-row lg:overflow-auto">
                <div className="relative flex min-h-[400px] w-full flex-col lg:min-h-[auto] lg:w-1/2 lg:overflow-auto">
                    <SegmentContainer>
                        <Segment shadow>
                            <SchemaModelHomeOverview tenant={tenant}></SchemaModelHomeOverview>
                        </Segment>
                    </SegmentContainer>
                </div>
                <div className="relative flex min-h-[400px] w-full flex-col lg:min-h-[auto] lg:w-1/2 lg:overflow-auto">
                    <SegmentContainer>
                        <Segment shadow>
                            {/* Tabbed header for Datasets / Views */}
                            <div className="flex border-b border-gray-200 mb-0">
                                <button
                                    onClick={() => onTabChange("datasets")}
                                    className={`px-4 py-2 text-sm font-semibold transition-colors cursor-pointer border-b-2 ${
                                        activeTab === "datasets"
                                            ? "text-blue-600 border-blue-600 bg-white"
                                            : "text-gray-600 border-transparent hover:bg-gray-50"
                                    }`}
                                >
                                    Datasets
                                </button>
                                <button
                                    onClick={() => onTabChange("views")}
                                    className={`px-4 py-2 text-sm font-semibold transition-colors cursor-pointer border-b-2 ${
                                        activeTab === "views"
                                            ? "text-blue-600 border-blue-600 bg-white"
                                            : "text-gray-600 border-transparent hover:bg-gray-50"
                                    }`}
                                >
                                    Views
                                </button>
                            </div>
                            {activeTab === "datasets" ? (
                                <DataSetHomeOverview tenant={tenant} onDataSetSelected={onDataSetSelected}></DataSetHomeOverview>
                            ) : (
                                <ViewsHomeOverview tenant={tenant} onViewSelected={onViewSelected}></ViewsHomeOverview>
                            )}
                        </Segment>
                    </SegmentContainer>
                </div>
            </div>
            <div className="relative flex size-full flex-1 flex-col gap-4 lg:flex-row lg:overflow-auto">
                <div className="relative flex min-h-[400px] w-full flex-col lg:min-h-[auto] lg:w-1/2 lg:overflow-auto">
                    <SegmentContainer>
                        <Segment shadow>
                            <DataObjectJobHomeOverview tenant={tenant}></DataObjectJobHomeOverview>
                        </Segment>
                    </SegmentContainer>
                </div>
                <div className="relative flex min-h-[400px] w-full flex-col lg:min-h-[auto] lg:w-1/2 lg:overflow-auto">
                    <SegmentContainer>
                        <Segment shadow>
                            {activeTab === "datasets" ? (
                                <DataSetInsightsHomeOverview tenant={tenant} dataSetId={selectedDataSetId} refreshFlag={dataSetInsightsRefreshFlag}></DataSetInsightsHomeOverview>
                            ) : (
                                <ViewInsightsHomeOverview tenant={tenant} viewId={selectedViewId}></ViewInsightsHomeOverview>
                            )}
                        </Segment>
                    </SegmentContainer>
                </div>
            </div>
        </FlexContainerLayout>
    );
}

export default Home;
